module.exports = __webpack_public_path__ + "static/media/bb.195c3a8e.svg";